import { Injectable, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Card, RemoteSet } from "@models/card.model";
import { Proxy } from "@models/scrap.model";
import { Api } from '@services/api.service';
import { of, shareReplay, filter, map, tap } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class Scrap{
	private readonly api=inject(Api);

	private readonly remoteSets$=this.getSetList$();
	private readonly remoteSets=toSignal(this.remoteSets$, {initialValue: []});

	private getSetList$(){
		return this.api.get<RemoteSet[]>('/scrap/sets')
			.pipe(
				shareReplay(1)
			);
	}

	getRemoteSetList(){
		if(this.remoteSets().length>0)
			return of(this.remoteSets());
		else
			return this.remoteSets$;
	}

	getremoteSet(id: string){
		return this.getRemoteSetList().pipe(
			map(remotes => {
				let result: RemoteSet[]=remotes.filter((remote: RemoteSet) => remote.id==id);
				return ((result.length)? result[0] : null)
			}),
		);
	}

	importSet(id: string){
		return this.api.get<any>(`/scrap/sets/${id}`)
			.pipe(
				tap(() => this.remoteSets().filter((remote: RemoteSet) => remote.id==id)[0].lastUpdate=new Date())
			);
	}

	importCard(setId: string, cardId: string){
		return this.api.get<Card>(`/scrap/sets/${setId}/cards/${cardId}`);
	}

	getProxies(){
		return this.api.get<Proxy[]>(`/scrap/proxies`);
	}

	getProxy(ref: string){
		return this.getProxies()
			.pipe(
				map(proxies => proxies.find((p: Proxy) => p.ref==ref))
			);
	}

	addProxie(proxy: Proxy){
		return this.api.post<Proxy>(`/scrap/proxies`, proxy);
	}

	setProxie(proxy: Proxy){
		return this.api.post<Proxy>(`/scrap/proxies/${proxy.ref}`, proxy);
	}

	removeProxy(ref: string){
		return this.api.delete<Proxy>(`/scrap/proxies/${ref}`);
	}
}